import { render, staticRenderFns } from "./TheFilterMainWheelAuto.vue?vue&type=template&id=3d9068e8&"
import script from "./TheFilterMainWheelAuto.vue?vue&type=script&lang=js&"
export * from "./TheFilterMainWheelAuto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports